module.exports = __webpack_public_path__ + "img/two1Green.fe43ba28.png";